<script>
    import Progress from "./onboarding/Progress.svelte";

    let progress = 0.0;

    window.addEventListener("route:progress", (e) => {
        progress = e.detail.progress;
    });
</script>

<div class="arrival">
    <Progress {progress} />
    <div class="description">Building new route, please wait...</div>
</div>

<style>
    .arrival {
        padding: var(--spacing);
    }

    .description {
        margin-top: 1em;
    }
</style>
